import {Accordion, AccordionSummary, AccordionDetails, Chip, LinearProgress, Stack, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import Constants from "../../../../utils/constants";
import OperateurAccordion from "./OperateurAccordion";
import {dashboardHelper} from "../utils/dashboardHelper";

function ClientAccordion({client, data, selectedDate, onTourneeDetailClick, onTourneeImpossibleClick, onMenuClick}) {
    return (
        <Accordion sx={{border: '1px solid lightgray'}} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <Stack direction="row" spacing={2} justifyContent="space-between" width="100%" paddingRight="2rem">
                    <Stack direction="row" spacing={2} alignItems="center">
                        {/* Statut global client */}
                        {/* A remplacer plus tard par StatutBadge réutilisable si besoin */}
                        <Chip label={dashboardHelper.getStatutLabel(data)}
                              sx={{backgroundColor: dashboardHelper.getStatutColor(data), color: "white"}}/>

                        <Stack direction="row" spacing={0} alignItems="center">
                            <AssignmentInd sx={{color: Constants.COLOR_THEME_BLUE}}/>
                            <Typography variant="h5">{client}</Typography>
                        </Stack>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                        <Chip label={`${data.totalTours} tournée(s)`}/>
                        <Chip label={`${data.totalALaver} bacs`} sx={{backgroundColor: Constants.COLOR_THEME_BLUE, color: 'white'}}/>
                        <Chip label={`${data.totalBacsLaves} lavé(s)`} sx={{backgroundColor: Constants.COLOR_THEME_GREEN, color: 'white'}}/>
                        {data.totalBacsImpossible > 0 &&
                            <Chip label={`${data.totalBacsImpossible} impossible(s)`} sx={{backgroundColor: Constants.COLOR_THEME_RED, color: 'white'}}/>
                        }
                    </Stack>
                </Stack>

                <LinearProgress
                    variant="determinate"
                    value={dashboardHelper.getClientProgress(data)}
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '4px',
                        backgroundColor: '#e0e0e0',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: Constants.COLOR_THEME_GREEN,
                        },
                    }}
                />
            </AccordionSummary>

            <AccordionDetails>
                {Object.entries(data.operateurs).map(([operateur, operateurData]) => (
                    <OperateurAccordion
                        key={operateur}
                        operateur={operateur}
                        data={operateurData}
                        selectedDate={selectedDate}
                        onTourneeDetailClick={onTourneeDetailClick}
                        onTourneeImpossibleClick={onTourneeImpossibleClick}
                        onMenuClick={onMenuClick}
                    />
                ))}
            </AccordionDetails>
        </Accordion>
    );
}

export default ClientAccordion;
